module.exports = __webpack_public_path__ + "static/img/success.a28402e5.svg";